module.exports = __webpack_public_path__ + "img/Bereitstellungsraum.1a3e0452.svg";